import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { FnrPopoverWithScroll } from "UI/FnrPopover2";

import capitalize from "Utilities/capitalize";

const options = [
  {
    id: "weekly",
    label: "Weekly",
  },
  {
    id: "monthly",
    label: "Monthly",
  },
  {
    id: "quarterly",
    label: "Quarterly",
  },
  {
    id: "annually",
    label: "Annually",
  },
];

export default function RecurringIntervalOptions({
  selected,
  onSelect,
  fundColor,
  disabled = false,
}) {
  const ref = useRef();
  const [show, setShow] = useState(false);

  const toggle = () => {
    if (disabled) return;
    setShow((show) => !show);
  };

  const handleSelection = (selection) => {
    setShow(false);
    onSelect(selection);
  };

  return (
    <React.Fragment>
      <Button
        data-cy="recurringIntervalListBtn"
        ref={ref}
        onClick={toggle}
        color={fundColor}
        disabled={disabled}
        open={show}
      >
        <BtnText $color={fundColor}>{capitalize(selected?.label)}</BtnText>
        <DropdownIcon icon={faChevronDown} $show={show} />
      </Button>
      <FnrPopoverWithScroll
        buttonRef={ref}
        show={show}
        color="white"
        location="bottom"
        onShouldClose={() => setShow(false)}
      >
        <OptionsWrapper>
          {options.map((option) => {
            return (
              <Option
                data-cy={option.id}
                key={option.id}
                onClick={() => handleSelection(option)}
                $selected={option.id === selected.id}
                $fundColor={fundColor}
              >
                <OptionText>{option?.label}</OptionText>
              </Option>
            );
          })}
        </OptionsWrapper>
      </FnrPopoverWithScroll>
    </React.Fragment>
  );
}

const Button = styled.button`
  border: none;
  color: ${(props) => props.color};
  background-color: transparent;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  border: 1px solid transparent;
  ${({ open, color }) =>
    open &&
    `border: 1px solid ${color};
    background: ${color};
    color: #FFF;
    `}
  border-radius: 8px;
  transition: all 0.6s;

  &:hover {
    transition: border 0.2s;
    border-radius: 8px;
    border: 1px solid
      ${({ open, color }) => (open ? color : "rgba(190, 195, 199, 1)")};
  }
  &:focus-within {
    transition: border 0.2s;
    border-radius: 8px;
    border: 1px solid
      ${({ open, color }) => (open ? color : "rgba(190, 195, 199, 1)")};
  }
`;

const DropdownIcon = styled(FontAwesomeIcon)`
  transform: ${(props) => `rotate(${props.$show ? "-180deg" : 0})`};
  transition: transform ease-in-out 0.2s;
  margin-left: 6px;
`;

const BtnText = styled.span`
  font-weight: 600;
  /* border-bottom: ${(props) => `1px solid ${props.$color}`}; */
  //text-decoration: underline;
  font-size: 16px;
`;

const OptionsWrapper = styled.ul`
  border-radius: 0.5rem;
  background: white;
  color: hsl(0, 0%, 30%);
  list-style: none;
  padding: 1px 4px;
  margin: 0;
`;

const OptionText = styled.span`
  display: inline-block;
  transition: all 0.3s ease-in-out;
`;

const Option = styled.li`
  margin: 4px;
  padding: 6px 8px;
  border-radius: 0.5rem;
  background: ${(props) => (props.$selected ? props.$fundColor : "none")};
  font-weight: ${(props) => (props.$selected ? 600 : "inherit")};
  color: ${(props) => (props.$selected ? "white" : "inherit")};

  &:hover {
    background: ${(props) =>
      props.$selected ? props.$fundColor : "hsl(0 0% 95%)"};
    cursor: pointer;

    ${OptionText} {
      transform: scale(1.1);
    }
  }
`;
